import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { FaBars, FaTimes, FaUser } from "react-icons/fa";
import { NavLink } from "react-router-dom";
import FileUploadModal from "./FileUploadModal";
import TopRightAd from "../Agent/TopRightAd";






const UserHeader = ({ Logout }) => {

  useEffect(() => {
    const agent = JSON.parse(localStorage.getItem("agent"));

    if (agent?.status === 'pushed') {
      Logout();
      alert("Access denied: Your account is paused.");
    }
  }, []);


  const [menuOpen, setMenuOpen] = useState(false);
  const [userMenuOpen, setUserMenuOpen] = useState(false);

  const toggleMenu = () => setMenuOpen(!menuOpen);
  const toggleUserMenu = () => setUserMenuOpen(!userMenuOpen);
  const closeMenus = () => {
    setMenuOpen(false);
    setUserMenuOpen(false);
  };
  const isAgent = !!localStorage.getItem("agent_token"); // true if token exists

  return (
    <>
      <header className="navbar navbar-expand-lg bg-light px-3 shadow">
        {/* {isAgent && (
           <TopRightAd/>
              )} */}
        <div className="container-fluid">
          {/* Logo */}
          <Link to="/" className="navbar-brand">
            <img src="/assets/img/logo/header-logo10a.svg" alt="Logo" height="40" />
          </Link>

          {/* Hamburger Icon */}
          <button className="navbar-toggler" onClick={toggleMenu}>
            {menuOpen ? <FaTimes size={24} /> : <FaBars size={24} />}
          </button>

          {/* Navbar Links */}
          <div className={`collapse navbar-collapse ${menuOpen ? "show" : ""}`}>
            <ul className="navbar-nav ms-auto gap-20">
              <li className="nav-item">
                <NavLink to="/" className="nav-link text-black" onClick={closeMenus}>
                  Home
                </NavLink>
              </li>


              <li className="nav-item">
                <NavLink
                  to={isAgent ? "/agentprofile" : "/profile"}
                  className="nav-link text-black"
                  onClick={closeMenus}
                >
                  Profile
                </NavLink>
              </li>

              {isAgent && (
                <li className="nav-item">
                  <NavLink to="bookservice"
                    className="nav-link text-black"
                    onClick={closeMenus}>
                    Book Service
                  </NavLink>
                </li>
              )}

              <li className="nav-item">
                <NavLink
                  to={isAgent ? "/agentservices" : "/user_services"}
                  className="nav-link text-black"
                  onClick={closeMenus}
                >
                  {isAgent ? "Orders" : "My Services"}
                </NavLink>
              </li>



              <li className="nav-item">
                <NavLink to={isAgent ? "/agentuploads" : "/uploads"} className="nav-link text-black" onClick={closeMenus}>
                  KYC Upload
                </NavLink>
              </li>



              {!isAgent && (
                <li className="nav-item">
                  <NavLink to="ticket"
                    className="nav-link text-black"
                    onClick={closeMenus}>
                    Tickets
                  </NavLink>
                </li>
              )}

              <li className="nav-item dropdown">
                <button className="nav-link btn btn-link text-black" onClick={Logout}>
                  Logout
                </button>
              </li>
            </ul>

          </div>

        </div>

      </header>

    </>

  );
};

export default UserHeader;
